import { IconButton } from '@mui/material';
import ArrowIcon from '../../../homepage/bannerCarousal/ArrowIcon';
import styles from './Body.module.scss';

export function ImageBackground({ imageComponent }) {
  return <div className={styles.imageContainer}>{imageComponent}</div>;
}

export function MobileContent({ onNext, onPrev, listItems, currentIdx }) {
  return (
    <div className={styles.mobileContent}>
      <ListItem idx={currentIdx} title={listItems[currentIdx].title}></ListItem>
      <DescriptionDetails
        details={listItems[currentIdx].description.details}
        text={listItems[currentIdx].description.text}
        isMobile
      />
      <NavArrows handleNext={onNext} handlePrev={onPrev}></NavArrows>
    </div>
  );
}

export function NavArrows({ handlePrev, handleNext }) {
  return (
    <div className={styles.nav}>
      <IconButton
        className={styles.arrowsIcon}
        color="primary"
        size="large"
        onClick={handlePrev}
      >
        <ArrowIcon isRotated={true} color={'black'} />
      </IconButton>
      <IconButton
        className={styles.arrowsIcon}
        color="primary"
        size="large"
        onClick={handleNext}
      >
        <ArrowIcon isRotated={false} color={'black'} />
      </IconButton>
    </div>
  );
}

export function ListItem({ idx, title }) {
  return (
    <div className={styles.listItem}>
      <div className={styles.listItemContent}>
        <span className={styles.listCounter}>{`0${idx + 1}`}</span>
        <span style={{ marginRight: '5px' }}>{' • '}</span>
        <span>{title}</span>
      </div>
    </div>
  );
}

export function DescriptionDetails({ text, details, isMobile }) {
  return (
    <div
      style={{
        display: isMobile ? 'block' : 'flex',
      }}
    >
      {!isMobile && (
        <div className={styles.lineContainer}>
          <div className={styles.container}>
            <div className={styles.line}>
              <div className={styles.circle} />
            </div>
          </div>
        </div>
      )}
      <div className={styles.descriptionDetails}>
        <div
          className={styles.flexContainer}
          style={{
            textAlign: isMobile ? 'center' : 'left',
          }}
        >
          <div className={styles.textTitle}>{text}</div>
          <div className={styles.textDetails}>{details}</div>
        </div>
      </div>
    </div>
  );
}
